import React from 'react';
import { Message, Spinner, SpinnerOverlay } from './LoadingSpinner.style';

const LoadingSpinner = ({ visible, message }) => (
	<SpinnerOverlay visible={visible}>
		<Spinner />
		{message && <Message>{message}</Message>}
	</SpinnerOverlay>
);

export default LoadingSpinner;
